import PageWrapper from '/components/page-wrapper'
import HelpText from '../help/support-new'

import RequestForm from '../components/support/form'
import Menu from '/components/support/nav-menu'

const SupportNewThread = () => {

  return (
    <PageWrapper title="Signup" HelpText={HelpText} heading="Request Support" menu={<Menu />}>
      <div className='flex flex-row w-full justify-center items-center mt-20'>
        <RequestForm />
      </div>
    </PageWrapper>
  )
}

export default SupportNewThread